export const iconFontAwesomeEnergyPlugCircleXmark = (
	<i className="fa-solid fa-plug-circle-xmark"></i>
);
